import { isMessageSeen } from './isMessageSeen';

export const getAmountOfNotSeenMessages = (tickets, userId) =>
	tickets?.reduce((prev, current) => prev + isMessageSeen(current, userId), 0);
